export default function Pandas_Correlations() {
  return <div>Pandas_Correlations </div>;
}
